import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type DevicesState, type DevicesActionTypes } from 'app/store/types';

const initialState: DevicesState = {};

const devicesReducer = (state = initialState, action: DevicesActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { devices },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(devices && { byId: devices }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'devices',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	devicesReducer,
);

// Selectors
export const getDevicesById = ({ app: { selectedLicenseGroupId }, devices }: RootState) =>
	devices[selectedLicenseGroupId].byId;

export const getDevices = createSelector([getDevicesById], (devicesById) => Object.values(devicesById));
